<!---Diálogo de selección de productos--->
<p-dialog 
    header="Buscador de Productos/Servicios"
    [(visible)]="visible" 
    modal="modal" showEffect="fade" 
    [breakpoints]="{ '960px': '90vw', '640px': '100vw' }"
    [style]="{ width: '90vw' }"
    (onHide)="cerrarPopup(false);"   
    [closable]="true"
    styleClass="p-dialog-product">
    <ng-template pTemplate="header">
        <div class="surface-section px-2 md:px-3 lg:px-4 text-center flex-auto">
            <div class="mb-3 font-bold text-2xl">
                <span class="text-900">¡Atención!, </span>
                <span class="text-blue-600">verifique el precio e impuesto que aplica</span>
            </div>
            <div class="text-700 text-sm mb-2">Tus productos y servicios <strong>{{currentUser.initials}}</strong>.</div>
            <div class="flex align-items-center justify-content-between">
                <span class="p-input-icon-left w-full" *ngIf="!cargarTodos">
                    <i class="pi pi-search"></i>
                    <input
                        pInputText
                        type="text"
                        (input)="filteredProductByKeywordRemote($event)"
                        placeholder="{{appConfig.ux.searchMsg}}"
                        class="w-full"/>
                </span>
                <span class="p-input-icon-left w-full" *ngIf="cargarTodos">
                    <i class="pi pi-search"></i>
                    <input
                        pInputText
                        type="text"
                        (input)="filteredProductByKeywordLocal($event)"
                        placeholder="{{appConfig.ux.searchMsg}}"
                        class="w-full"/>
                </span>
                <button pButton pRipple
                        type="button" 
                        pTooltip="{{ appConfig.ux.actions.add }}" tooltipPosition="bottom"
                        icon="pi pi-plus" class="p-button-rounded p-button-secondary p-button-sm ml-1"
                        (click)="nuevoProducto()">
                </button>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="content">
        <div class="surface-section px-2 md:px-3 lg:px-4 text-center">
            <div class="grid">
                <div *ngFor="let item of productsFiltered" 
                     class="col-12 md:col-3 p-1 h-full">
                    <div class="col-12">
                        <button *ngIf="item.amount && item.amount > 0"
                                pButton pRipple
                                type="button" 
                                pTooltip="{{ 'Quitar' }}" tooltipPosition="bottom"
                                icon="pi pi-times" class="p-button-rounded p-button-plain p-button-sm" style="float: right;"
                                (click)="deseleccionarProducto($event, item)">
                        </button>
                    </div>
                    <div [class]="item.amount && item.amount > 0 ? 'col-12 bg-bluegray-100' : ''">
                        <div class="mb-5"></div>
                        <div class="mb-3 text-700 text-sm line-height-3 uppercase">{{item.productType == 'SERVICE' ? 'Servicio' : 'Producto'}}</div>
                        <p-button [styleClass]="(item.amount && item.amount > 0) ? 'p-button-primary shadow-1 p-3' : 'p-button-text shadow-1 p-3'"
                                  (click)="seleccionarProducto($event, item)"
                                  (dblClick)="seleccionarProducto($event, item)">
                            <ng-template pTemplate="content">
                                <div class="flex-auto w-full">
                                    <img [src]="!item.photo ? '/assets/layout/icons/product.png' : item.photo" class="h-2rem"/>
                                </div>
                            </ng-template>
                        </p-button>
                        <div class="text-900 mt-1 mb-3 font-medium text-blue-600">${{item.price ? item.price.toFixed(2): appConfig.ux.undefinedNumber}} <p-badge [value]="'IVA ' + item.taxFactor"></p-badge></div>
                        <div class="text-700 text-sm line-height-3 uppercase">
                            <span>{{item.name ? item.name :  appConfig.ux.undefinedString}}</span>
                            <button pButton pRipple
                                    type="button" 
                                    pTooltip="{{ 'Editar' }}" tooltipPosition="right"
                                    icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-sm p-button-info h-1rem"
                                    (click)="editarProducto($event,item)">
                            </button>
                        </div>
                        <p-inputNumber *ngIf="item.amount && item.amount > 0"
                                       #productAmount="ngModel" id="productAmount" name="productAmount" 
                                       [(ngModel)]="item.amount" 
                                       (onBlur)="seleccionarProducto($event, item)"
                                       placeholder="{{appConfig.ux.undefinedNumber}}"
                                       mode="decimal" locale="en-US"
                                       [min]="0" [minFractionDigits]="3" [maxFractionDigits]="3"
                                       prefix="Cantidad "
                                       required>
                        </p-inputNumber>
                    </div>
                </div>
                <div *ngIf="(!productsFiltered || !productsFiltered.length)"
                     class="col-12 md:col-12 mb-1 p-6">
                    <i *ngIf="!processFilter" class="pi pi-shopping-bag text-8xl"></i>
                    <br>
                    <strong *ngIf="!processFilter && (products && products.length)">{{appConfig.ux.emptyMsg}}</strong>
                    <i *ngIf="processFilter" class="pi pi-spin pi-spinner text-8xl"></i>
                </div>  
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
    </ng-template>
</p-dialog>
<!--Diálogos de creación/edición de product--> 
<app-producto [mostrarEditor] = "mostrarEditor" 
              [producto] ="_producto"
              [estaCargandoDatos] = "false"
              (productoGuardado) = "handleProductoGuardado($event);"></app-producto>